import { useQuery } from "@tanstack/react-query";

import { getLatestPlatformContract } from "services";

import { GET_PLATFORM_CONTRACT } from "consts";

import { PlatformContract } from "models";

export const useGetLatestPlatformContract = () =>
  useQuery<PlatformContract>({
    queryKey: [GET_PLATFORM_CONTRACT],
    queryFn: getLatestPlatformContract,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
